<template>
  <div>
    <p class="notification_label">{{ notification.data.webhook.label }} Webhook Failed. Contact Support</p>
    <button-link @click="goToPhoneWebhooksPage">Go To Webhooks</button-link>
  </div>
</template>

<script>
import router from "../../../router";
import api from "../../../api";
import dates from "../../../services/dates";

export default {
  name: "WebhookFailedNotification",
  props: {
    notification: Object
  },
  methods: {
    goToPhoneWebhooksPage() {
      api.notifications.markRead({ notification_id: this.notification.id }).then(() => {
        // NOTE: The database read_at will be different from now, but read_at just needs a date
        // in order for this to work. We don't show the read at time.
        this.notification.read_at = dates.getNowISO()
      })
      router.push('/settings/webhooks');
    },
  },
}
</script>

<style lang="scss" scoped>
.notification_label {
  margin-bottom: 2px;
  font-size: 0.875rem;
}
</style>
